import { Breadcrumbs, Typography, Box, Container, Link as MUILink } from "@mui/material";
import { Link } from "react-router-dom";
import React from "react";
import HomeIcon from "@mui/icons-material/Home";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

export default function IconBreadcrumbs({ name }) {
  return (
    <Box
      sx={{
        width: "100%",
        py: { xs: 4, md: 6 },
        background: "linear-gradient(135deg, #0d1b2a 0%, #1b263b 100%)",
        color: "#fff",
        borderBottom: "2px solid #0d1b2a",
        borderTop: "2px solid #1b263b",
        boxShadow: "0 6px 12px rgba(0, 0, 0, 0.7)",
        fontFamily: "'Poppins', sans-serif",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 3,
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: 800,
              color: "#00e5ff",
              textTransform: "uppercase",
              letterSpacing: 1.5,
              fontSize: { xs: "2rem", md: "2.8rem" },
              lineHeight: 1.2,
            }}
          >
            {name}
          </Typography>

          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" sx={{ color: "#90a4ae" }} />}
            aria-label="breadcrumb"
            sx={{
              "& .MuiBreadcrumbs-ol": {
                display: "flex",
                alignItems: "center",
              },
              "& a": {
                fontSize: "1rem",
                fontWeight: 500,
                color: "#90caf9",
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
                transition: "color 0.3s",
                "&:hover": {
                  color: "#fff",
                },
              },
              "& .MuiTypography-root": {
                color: "#cfd8dc",
                fontWeight: 600,
                fontSize: "1rem",
              },
            }}
          >
            <MUILink component={Link} to="/" underline="none">
              <HomeIcon fontSize="small" sx={{ mr: 0.5 }} />
              Home
            </MUILink>
            <Typography>{name}</Typography>
          </Breadcrumbs>
        </Box>
      </Container>
    </Box>
  );
}
